export default {
  title: "آموزش زبان کودک و نوجوان در منزل شما",

  features: [
    "۲۰ سال سابقه آموزش کودک و نوجوان",
    "برنده مدال طلای جشنواره iCAN کانادا در بخش آموزش",
    "تقدیر شده از سازمان مخترعین دنیا در آمریکا در بخش آموزش",
  ],

  description:
    "مؤسس این مجموعه آقای محمد خالد فیضی، مؤلف کتاب‌های Joy Phonics هستند و تمام سناریوهای آموزشی توسط ایشان نوشته می‌شود.",
};
